import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 20,
    // paddingHorizontal: 20,
  },
  headerTitle: {
    color: '#EA580C', // matching orange from HTML (#ff8e4d approx)
    fontSize: 18,
    textAlign: 'right',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  headerNote: {
    fontSize: 9,
    
    textAlign: 'right',
    lineHeight: 1.4,
  },
});

const BillVoucher = ({ invoice }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.headerTitle}>Booking Voucher</Text>
    <Text style={styles.headerNote}>
      Please present either an electronic or paper copy of your booking confirmation upon check-in
    </Text>
  </View>
);

export default BillVoucher;
